var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: { "is-in-iframe": _vm.isInIframe },
      attrs: { id: "sidenav-layout" }
    },
    [
      _c(
        "nav",
        { staticClass: "sidenav" },
        [_c("ma-side-nav", { attrs: { items: _vm.dataUserRoutes } })],
        1
      ),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [_c("router-view")],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }